import { useEffect } from "react";
import { setLangMy } from "../redux/sys-slice";
import { useAppDispatch as useDispatch, useAppSelector as useSelector } from './ReduxHooks';

const useLanguageNavigator = (availableLanguages: string[], defaultLanguage = "en") => {
    const dispatch = useDispatch();
    const language = useSelector(state => state.sys.language)

    // Helper function to safely get the language from localStorage
    const getSavedLanguage = () => {
        if (typeof window !== "undefined") {
            return localStorage.getItem("preferredLanguage");
        }
        return null;
    };

    // Helper function to safely get the browser language
    const getBrowserLanguage = () => {
        if (typeof window !== "undefined") {
            const browserLanguage = navigator.language || navigator.languages[0]; // e.g., "en-US"
            const primaryLanguage = browserLanguage.split("-")[0]; // Extract the primary language, e.g., "en"
            return primaryLanguage;
        }
        return defaultLanguage;
    };

    // Function to set the language in Redux and localStorage
    const setLanguage = (lang: string) => {
        dispatch(setLangMy(lang));
        if (typeof window !== "undefined") {
            localStorage.setItem("preferredLanguage", lang);
        }
    };

    // Initialize language
    useEffect(() => {
        const savedLanguage = getSavedLanguage();
        if (savedLanguage && availableLanguages.includes(savedLanguage)) {
            setLanguage(savedLanguage);
        } else {
            const browserLanguage = getBrowserLanguage();
            const userLanguage = availableLanguages.includes(browserLanguage)
                ? browserLanguage
                : defaultLanguage;

            if (!savedLanguage) {
                setLanguage(userLanguage);
            }
        }
    }, [availableLanguages, defaultLanguage]);

    // Function to manually update the language
    const updateLanguage = (newLanguage: string) => {
        if (availableLanguages.includes(newLanguage)) {
            setLanguage(newLanguage);
        }
    };

    return { language, updateLanguage };
};

// const useLanguageNavigator = (availableLanguages: string[], defaultLanguage = localStorage.getItem("preferredLanguage") ?? "en") => {
//     // const [language, setLanguage] = useState<string>(defaultLanguage);
//     const dispatch = useDispatch()
//     const language = useSelector(state => state.sys.language)
//     const setLanguage = (lang: string) => {
//         dispatch(setLangMy(lang))
//     };
//     const getLanguageFromNavigator = (languages: string[]) => {
//         const browserLanguage = navigator.language || navigator.languages[0]; // e.g., "en-US"
//         const primaryLanguage = browserLanguage.split("-")[0]; // Extract the primary language, e.g., "en"
//         return languages.includes(primaryLanguage) ? primaryLanguage : defaultLanguage;
//     };

//     useEffect(() => {
//         // Check local storage for saved language preference
//         const savedLanguage = localStorage.getItem("preferredLanguage");
//         if (savedLanguage && availableLanguages.includes(savedLanguage)) {
//             setLanguage(savedLanguage);
//         } else {
//             // Use the navigator's language as the default
//             const userLanguage = getLanguageFromNavigator(availableLanguages);
//             if (!savedLanguage) {
//                 localStorage.setItem("preferredLanguage", userLanguage);
//             }
//             setLanguage(userLanguage);
//         }
//     }, [availableLanguages]);

//     const updateLanguage = (newLanguage: string) => {
//         if (availableLanguages.includes(newLanguage)) {
//             setLanguage(newLanguage);
//             localStorage.setItem("preferredLanguage", newLanguage);
//         }
//     };

//     return { language, updateLanguage };
// };

export default useLanguageNavigator;